// src/components/meeting/panels/DetailPanel.jsx
import MeetingDetailCard from "../MeetingDetailCard";

export default function DetailPanel({
  item,
  projectId,
  onEdit,
  onDeleted,
  onClose, // 필요 시 버튼에서 사용
}) {
  if (!item) return null;
  return (
    <MeetingDetailCard
      item={item}
      projectId={projectId}
      onEdit={onEdit}
      onDeleted={onDeleted}
    />
  );
}
